import React, { useEffect } from 'react';
import Loader from '../layout/Loader';
import toast from 'react-hot-toast';
import { useMyOrdersQuery } from '../../redux/api/bookingApi';
import { MDBDataTable } from 'mdbreact';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import MetaData from '../layout/MetaData';
import { useDispatch } from 'react-redux';
import { clearVehicleName } from '../../redux/features/userAddressInfoSlice';
import '../../css/orders.css';

const MyOrders = () => {
  const { data, isLoading, error } = useMyOrdersQuery({ pollingInterval: 60000 });
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const orderSuccess = searchParams.get('order_success');

  useEffect(() => {
    if (orderSuccess) {
      dispatch(clearVehicleName());
      navigate('/me/orders');
    }
  }, [orderSuccess]);

  const setOrders = () => ({
    columns: [
      { label: 'Order Status', field: 'orderStatus', sort: 'asc' },
      { label: 'Actions', field: 'actions', sort: 'asc' },
    ],
    rows: data?.orders?.map((order) => ({
      orderStatus: order?.orderStatus,
      actions: (
        <Link to={`/me/booking/${order?._id}`} className="btn btn-primary btn-sm" id="order-view-admin-orders">
          <i className="fa fa-eye" id="order-view-logo" />
        </Link>
      ),
    })) || [],
  });

  if (isLoading) return <Loader />;

  return (
    <>
      <MetaData title="My Bookings" />
      <div className="container py-4">
        <h2 className="mb-4 text-center">{data?.orders?.length || 0} Bookings</h2>
        <div className="card p-3">
          <MDBDataTable
            data={setOrders()}
            className="px-3"
            id="user-orders-id"
            bordered
            striped
            hover
            responsive
            paging={data?.orders?.length > 10}
          />
        </div>
      </div>
    </>
  );
};

export default MyOrders;